import axios from "axios";

function send(reqConfig, data) {
  let uri = "";
  if (reqConfig.method === "get") {
    uri = Object.keys(data).reduce((uri, key, index) => {
      if (index === 0) {
        uri += `?${key}=${data[key]}`;
      } else {
        uri += `&${key}=${data[key]}`;
      }

      return uri;
    }, "");
  }

  return axios({
    headers: {
      Authorization: `Token ${reqConfig.token}`,
    },
    method: reqConfig.method,
    url: reqConfig.url + uri,
    timeout: 300000,
    data: data,
  });
}

function createReqConfig(serverUrl, method, entity, token) {
  const url = [serverUrl, entity].join("/") + "/";
  return {
    method: method,
    url: url,
    token: token,
  };
}

export default {
  send,
  createReqConfig,
};
